interface ArticleImageProps {
  url: string;
}

export const ArticleImage = ({ url }: ArticleImageProps) => {
  return (
    <div className="my-6 max-w-full w-fit overflow-hidden rounded-lg shadow-inner">
      <img
        src={url}
        alt=""
        className="w-full h-auto object-cover object-center rounded-lg border border-input"
      />
    </div>
  );
};
